import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Tooltip } from '@fiverr-private/fit';
import { isTouchDevice, collaborationEventBus } from '../../../Utils';
import { sendMixPanelEvent } from '../../../Utils/mixpanel';
import { ANNOTATION_CLICK_EVENT } from '../../../MediaViewer/consts';
import { CLICKED_COLLABORATION_TOGGLE_PANEL } from '../../../Utils/mixpanel/mixpanelEvents';
import { isExternalCollaborationTabSelected } from '../../selectors/groups';
import * as Translations from '../../providers/i18n';
import DesktopOpen from './DesktopOpen';
import DesktopClose from './DesktopClose';
import MobileOpen from './MobileOpen';
import MobileClose from './MobileClose';
import './style.scss';

const { POSITIONS } = Tooltip;

class CommentPanelButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isTouch: isTouchDevice()
        };

        this.onToggleClick = this.onToggleClick.bind(this);
    }
    componentDidMount() {
        if (this.state.isTouch) {
            collaborationEventBus.on(ANNOTATION_CLICK_EVENT, this.props.onClick);
        }
    }

    onToggleClick() {
        const {
            isOpen,
            onClick
        } = this.props;

        sendMixPanelEvent({
            eventName: CLICKED_COLLABORATION_TOGGLE_PANEL,
            eventData: {
                'Toggle State': !isOpen
            }
        });

        onClick();
    }

    render() {
        const {
            isOpen,
            collaborationsTabSelected,
            i18n
        } = this.props;

        const classes = classNames('comment-panel-toggle', { open: isOpen, 'dark-theme': collaborationsTabSelected });

        return (
            <button className={classes} onClick={this.onToggleClick}>
                <Tooltip content={<p className="tooltip">{i18n.t('attachments_preview.collaboration.comments.comments')}</p>} className="tooltip-container" delay={true} position={POSITIONS.LEFT}>
                    <DesktopOpen/>
                </Tooltip>
                <Tooltip content={<p className="tooltip">{i18n.t('attachments_preview.collaboration.comments.hide_comments')}</p>} className="tooltip-container" delay={true} position={POSITIONS.LEFT}>
                    <DesktopClose/>
                </Tooltip>
                <MobileOpen/>
                <MobileClose/>
            </button>
        );
    }
}

CommentPanelButton.propTypes = {
    onClick: PropTypes.func.isRequired,
    isOpen: PropTypes.bool,
    collaborationsTabSelected: PropTypes.bool,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

CommentPanelButton.defaultProps = {
    isOpen: false
};

const mapStateToProps = (state) => ({
    collaborationsTabSelected: isExternalCollaborationTabSelected(state)
});

export default compose(
    Translations.connect,
    connect(mapStateToProps))(CommentPanelButton);
